// extracted by mini-css-extract-plugin
export default {"icon__white":"Icon_icon__white__DSL9t"};